<div class="video-modal flex-wrap justify-center align-center" *ngIf="video">
  <div class="video-modal__wrap">
    <span
      ><img src="assets/images/close.svg" alt="x" (click)="closePlayer()"
    /></span>

    <video width="320" height="240" controls autoplay controlslist="nodownload" id="videoPlayer">
      <source [src]="video.videoUrl" />
      Your browser does not support the video tag.
    </video>
  </div>
</div>
